module.exports = __webpack_public_path__ + "img/southwest-spring-1920x550.518b60cd.jpg";